<template>
  <section :class="{'is-mobile-mode': isMobile}">
    <active-block :img="bg1" :respone="respone">
      <div class="btn-wrapper" :class="{'is-mobile': isMobile}">
        <!-- <template v-for="(product, productIndex) in productList">
          <button :key="'d' + productIndex" class="product-d" @click="toNby(product)">查看详情</button>
          <button :key="'e' + productIndex" class="product-e" @click="toProduct">以旧换新</button>
        </template> -->
        <button class="evaluate" @click="toProduct"></button>
        <!-- <button class="evaluate-v2" @click="toProduct"></button> -->
        <!-- <div class="evaluate-bg" @click="toProduct"></div> -->
        <!-- <button class="more" @click="back"></button> -->
      </div>
    </active-block>
  </section>
</template>

<script>
import ismobilejs from 'ismobilejs';
import ActiveBlock from '../../components/active-block/img-map';

const bg1 = require('./imgs/bg27.jpg');
const pcbg1 = require('./imgs/pcbg27.jpg');

export default {
  components: {
    ActiveBlock
  },
  data () {
    return {
      bg1: '',
      bg2: '',
      isMobile: false,
      respone: true,
      productList: [
        'https://www.nubia.com/product/s/1706',
        'https://www.nubia.com/product/s/1769',
        'https://www.nubia.com/product/s/1866',
      ],
      moreLink: 'https://activity.huanjixia.com/web/xystorelist/index.html?SrcPid=1452&bShowLatestStore=false#/'
    };
  },
  methods: {
    toProduct () {
      this.$router.push('/products/1');
    },
    toNby (url) {
      window.location.href = url || 'https://m.nubia.com'
    },
    back () {
      window.history.go(-1)
    }
  },
  mounted () {
    this.isMobile = ismobilejs.phone
    this.bg1 = this.isMobile ? bg1 : pcbg1;
  }
};
</script>

<style scoped>
  /* @media (--not-sm-viewport) {
    /deep/ .pic-wrap img {
      width: 100vw;
      min-width: 1920px;
    }
  } */

  .m-img {
    width: 100%;
  }

  .btn-wrapper {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    button {
      position: absolute;
      background-color: red;
      cursor: pointer;
      opacity: 0;
    }
    .evaluate {
      /* top: 514px;
      right: 365px;
      height: 100px;
      width: 300px; */
      top: 26vw;
      right: 19vw;
      width: 15vw;
      height: 6vw;
    }
    .evaluate-v2 {
      /* top: 1312px;
      right: 365px;
      height: 100px;
      width: 300px; */
      top: 67vw;
      right: 19vw;
      width: 15vw;
      height: 6vw;
    }
    .evaluate-bg {
      position: absolute;
      cursor: pointer;
      opacity: 0;
      /* top: 2060px; */
      top: 105vw;
      left: 0;
      /* height: 2400px; */
      width: 100%;
      height: 125vw;
    }
    .product-d, .product-e {
      width: 212px;
      height: 51px;
    }
    .product-d {
      &:nth-of-type(1) {
        top: 2075px;
        left: 1003px;
      }
      &:nth-of-type(3) {
        top: 3152px;
        left: 1003px;
      }
      &:nth-of-type(5) {
        top: 4234px;
        left: 1003px;
      }
    }
    .product-e {
      &:nth-of-type(2) {
        top: 2075px;
        left: 1230px;
      }
      &:nth-of-type(4) {
        top: 3152px;
        left: 1231px;
      }
      &:nth-of-type(6) {
        top: 4234px;
        left: 1231px;
      }
    }
    .more {
      top: 6150px;
      left: 50%;
      transform: translateX(-50%);
      width: 430px;
      height: 75px;
    }
    &.is-mobile {
      .evaluate {
        top: 0;
        left: 0;
        width: 100%;
        height: 142vw;
      }
      .evaluate-v2 {
        top: 42vw;
        left: 0;
        width: 100%;
        height: 42vw;
      }
      .evaluate-bg {
        top: 180vw;
        left: 0;
        height: 240vw;
        width: 100%;
      }
      .product-d, .product-e {
        width: 27vw;
        height: 10.2vw;
        background-color: rgba(0, 0, 0, .7);
      }
      .product-d {
        &:nth-of-type(1) {
          top: 364.3vw;
          left: 43.66667vw;
        }
        &:nth-of-type(3) {
          top: 453.5vw;
          left: 43.66667vw;
        }
        &:nth-of-type(5) {
          top: 542.5vw;
          left: 43.66667vw;
        }
      }
      .product-e {
        &:nth-of-type(2) {
          top: 364.3vw;
          left: 70.53333vw;
        }
        &:nth-of-type(4) {
          top: 453.5vw;
          left: 70.53333vw;
        }
        &:nth-of-type(6) {
          top: 542.5vw;
          left: 69.66667vw;
        }
      }
      .more {
        top: 754.56667vw;
        left: 50%;
        transform: translateX(-50%);
        width: 58.46667vw;
        height: 20.66667vw;
        background-color: rgba(0, 0, 0, .7);
      }
    }
  }
</style>
